import React, { createContext, useContext, useState, useEffect } from 'react';

export type Language = 'fr' | 'en';

const translations = {
  fr: {
    // Nav / Header
    nav_portfolio: "Portfolio",
    nav_duo: "Le Duo",
    nav_seo: "Profil IA & SEO",
    nav_contact: "Contact",
    nav_style: "Style :",
    nav_admin_exit: "Quitter Admin",
    nav_admin_enter: "Admin",
    nav_cta: "Raconter mon histoire",
    nav_sub_brand: "Châteaux & Mariages d'exception",

    // Hero
    hero_title: "LIFE-CAPTURED",
    hero_tagline: "L'art du mouvement & la poésie de la lumière",
    hero_description: "LIFE-CAPTURED est un studio de création visuelle d'exception basé au Teich sur le Bassin d'Arcachon. Mené par Yohann (réalisateur de films cinématiques) et Aurélie (photographe de l'instant intime), nous créons des reportages sur-mesure pour vos mariages au Teich, Biganos, Gujan-Mestras, La Teste-de-Buch, Arcachon, Mios, Cap Ferret, Bordeaux et dans toute l'Aquitaine.",

    // Portfolio
    portfolio_tag: "Reportages de Prestige",
    portfolio_title: "Histoires d'Amour & de Lumière",
    portfolio_subtitle: "Découvrez nos derniers récits d'amour et de lumière, capturés sur le vif entre terre et mer.",
    portfolio_filter_all: "Tous",
    portfolio_filter_photo: "Photo",
    portfolio_filter_video: "Vidéo",
    portfolio_filter_album: "Album d'art",
    portfolio_view_btn: "Voir le reportage",
    portfolio_empty: "Aucun média trouvé.",
    portfolio_ex_reportage: "Reportage d'exception",
    portfolio_film_hdr: "FILM HDR",
    portfolio_photo_num: "PHOTO NUMÉRIQUE",
    portfolio_seo_alt: "Alt-tag SEO :",
    portfolio_prev: "Média précédent",
    portfolio_next: "Média suivant",
    portfolio_close: "Fermer",

    // ServiceAreas / SEO Localisation
    seo_local_tag: "Ancrage Territorial & Mobilité",
    seo_local_title: "Votre histoire immortalisée au cœur du Bassin d'Arcachon & d'Aquitaine",
    seo_local_desc: "Nous intervenons en tant que <strong>photographe et vidéaste de mariage professionnels</strong> sur l'ensemble du Bassin d'Arcachon (<strong>Le Teich, Biganos, Gujan-Mestras, La Teste-de-Buch, Arcachon, Mios, Cap Ferret</strong>), à Bordeaux et dans toute l'Aquitaine. Notre fine connaissance des marées, de la lumière sur la Dune du Pilat et des plus beaux ports ostréicoles nous permet de sublimer chaque mariage avec une offre 100% sur-mesure.",
    seo_local_title_1: "Le Bassin d'Arcachon & Val de Leyre",
    seo_local_sub_1: "Le Teich, Biganos, Gujan, La Teste, Arcachon, Mios, Cap Ferret",
    seo_local_desc_1: "Basés au Teich, nous couvrons quotidiennement l'ensemble des communes du Bassin : des rivages sauvages du Cap Ferret aux ports ostréicoles de Gujan-Mestras et Biganos, en passant par le Val de Leyre (Mios), La Teste-de-Buch et la Ville d'Hiver d'Arcachon.",
    seo_local_title_2: "Châteaux & Vignobles d'Aquitaine",
    seo_local_sub_2: "Bordeaux, Saint-Émilion & Domaines de Prestige",
    seo_local_desc_2: "Nous accompagnons régulièrement les mariés dans les grands domaines viticoles du Bordelais, de Saint-Émilion, du Médoc et des châteaux historiques d'Aquitaine.",
    seo_local_title_3: "Offre 100% Sur-Mesure & Mobilité",
    seo_local_sub_3: "Aucun tarif rigide : une proposition adaptée à votre projet",
    seo_local_desc_3: "Chaque mariage étant unique, nous ne proposons pas de grille tarifaire standardisée. Nous concevons une proposition personnalisée selon le déroulé de votre journée, votre lieu de réception et vos souhaits artistiques.",
    seo_local_sectors: "Secteurs d'intervention privilégiés :",
    seo_local_guarantee_title: "Planification, Lumière & Devis Sur-Mesure",
    seo_local_guarantee_desc: "Nous étudions les marées du Bassin et la position du soleil pour programmer votre séance de couple à l'heure d'or.",
    seo_local_guarantee_cta: "Demander notre devis sur-mesure",

    // DuoProfile
    duo_tag: "Le Duo d'Artistes",
    duo_title: "Les Artisans de vos Souvenirs",
    duo_desc: "Un couple d'artistes complémentaires unissant la poésie de la photographie instantanée et la puissance cinématographique du film narratif pour immortaliser vos précieux moments au Teich, sur tout le Bassin d'Arcachon et en Aquitaine.",
    duo_sub_title: "Deux Regards, Une Synergie",
    duo_equip_vid: "ÉQUIPEMENT DE POINTE :",
    duo_equip_pho: "MATÉRIEL PHOTO :",
    duo_quote: "La force d'un duo, c'est d'être au même endroit sous deux angles magiques différents.",
    duo_synergy: "Photographe + Vidéaste synchronisés pour une harmonie parfaite",

    // Showreel
    showreel_tag: "Œuvres en mouvement",
    showreel_title: "Bandes-Démo & Récits Cinématiques",
    showreel_desc: "Plongez dans notre univers visuel à travers nos extraits de films de mariage de luxe et créations de prestige.",
    showreel_watch: "Regarder le film",
    showreel_intro_tag: "Immersion Émotionnelle",
    showreel_intro_title: "Bande-Démo Cinématique",
    showreel_intro_desc: "Le film de mariage ne documente pas seulement, il fige le rythme cardiaque d'une journée. Regardez notre showreel exclusif et ressentez l'ambiance authentique de nos créations.",
    showreel_pitch1_title: "Authenticity",
    showreel_pitch1_desc: "Pas de sourires forcés ni d'installations lourdes. Nous captons les rires volés, les larmes douces et les silences complices.",
    showreel_pitch2_title: "Qualité Cinéma Pro",
    showreel_pitch2_desc: "Tournage en Sony FX3 & FX30 4K Log avec enregistreur Atomos, stabilisateur DJI RS3 Pro, rail motorisé Zeapon, et drone DJI Mini 4 Pro.",
    showreel_pitch3_title: "Émotion Sonore",
    showreel_pitch3_desc: "Le son est 50% de l'expérience : nous enregistrons vos vœux, vos discours et l'environnement sonore pour un récit immersif.",
    showreel_ambient_badge: "RÉCIT CINÉMA • 4K HDR",
    showreel_demo_badge: "Bande-Démo :",
    showreel_open_external: "Ouvrir sur YouTube / Vimeo ↗",

    // FeaturedMasterpiece
    master_tag: "Sélection de Prestige",
    master_title: "Les Chefs-d'œuvre",
    master_desc: "Une collection vivante de nos plus belles créations. Cochez la petite étoile ⭐ sur vos photos préférées dans nos galeries pour choisir les chefs-d'œuvre qui défilent ici en rotation !",
    master_quote_fallback: "L'art est l'assemblage de fragments éparpillés d'éternité.",
    master_author_fallback: "Note d'intention d'Aurélie & Yohann",
    master_btn_reassemble: "Suivant ➔",
    master_teaser_tag: "Émergence de l'Instant",
    master_teaser_desc: "Découvrez nos clichés coups de cœur",

    // Contact
    contact_tag: "Création sur-mesure",
    contact_title: "Demande de Devis Personnalisé",
    contact_label_name: "Prénom & Nom",
    contact_label_email: "Adresse Email",
    contact_label_phone: "Téléphone",
    contact_label_date: "Date du mariage / événement",
    contact_label_location: "Lieu(x) de réception & Cérémonie",
    contact_label_service: "Prestation souhaitée",
    contact_label_message: "Votre histoire & Détails du projet",
    contact_submit: "Envoyer ma demande de devis",
    contact_success_title: "Demande de devis transmise avec succès !",
    contact_success_desc: "Nous vous recontacterons sous 24h avec une proposition sur-mesure.",
    contact_intro_tag: "Devis 100% Personnalisé",
    contact_intro_title: "Créons ensemble votre projet sur-mesure",
    contact_intro_desc: "Chaque mariage est unique. Nous construisons une proposition sur-mesure adaptée à vos besoins, au déroulé de votre journée et à votre lieu de réception au Teich, sur le Bassin d'Arcachon, à Bordeaux ou ailleurs en Aquitaine.",
    contact_studio_label: "Notre Studio",
    contact_hours_label: "Horaires d'ouverture",
    contact_social_label: "Rejoignez-nous sur les réseaux",
    contact_placeholder_name: "Ex: Alexandre & Sophie",
    contact_placeholder_email: "Ex: contact@monmail.com",
    contact_placeholder_phone: "Ex: 06 12 34 56 78",
    contact_placeholder_location: "Ex: Le Teich, Cap Ferret, Domaine de Larchey, Château de Roquetaillade...",
    contact_placeholder_message: "Décrivez-nous votre projet : l'ambiance souhaitée, les moments clés à immortaliser, vos attentes artistiques...",
    contact_sending: "Enregistrement de la demande...",
    contact_btn_send: "Obtenir mon devis personnalisé",
    contact_success_thanks: "Un grand merci d'avoir partagé votre projet avec nous ! Votre demande a été enregistrée dans notre système et transmise à Yohann & Aurélie. Nous étudierons votre dossier et reviendrons vers vous sous 24h avec un devis adapté.",
    contact_success_btn_another: "Envoyer un autre message",

    // FAQ
    faq_tag: "Des réponses à vos questions",
    faq_title: "Foire Aux Questions",
    faq_q1: "Quels sont vos tarifs et comment fonctionnent vos devis ?",
    faq_a1: "Nous ne proposons pas de tarifs fixes car chaque mariage est unique. Notre offre est 100% sur mesure, adaptée au nombre d'heures de présence, à vos lieux de réception (Bassin d'Arcachon, Bordeaux, Aquitaine) et au type de couverture choisi (Photo, Vidéo ou Duo). Contactez-nous pour recevoir un devis personnalisé gratuit sous 24h.",
    faq_q2: "Proposez-vous des formules combinant photo et vidéo ?",
    faq_a2: "Oui, notre spécialité absolue est le Duo complet Photo & Vidéo. Travailler ensemble en tant que couple nous permet d'assurer une harmonie visuelle parfaite, d'éviter les interférences physiques sur le terrain et de synchroniser nos prises de vue.",
    faq_q3: "Quelles sont les villes couvertes sur le Bassin d'Arcachon et en Aquitaine ?",
    faq_a3: "Nous sommes basés au Teich (33470) et couvrons l'ensemble des communes du Bassin : Le Teich, Biganos, Gujan-Mestras, La Teste-de-Buch, Arcachon, Mios, Cap Ferret, ainsi que Bordeaux, la Gironde et toute la région Aquitaine.",
    faq_q4: "Quels sont vos délais de livraison ?",
    faq_a4: "Pour les photos de reportage (livrées sur galerie en ligne privée sécurisée), le délai est de 4 à 6 semaines. Pour le film cinématique 4K HDR, le montage sonore et l'étalonnage minutieux prennent 6 à 8 semaines.",
    faq_q5: "Le drone est-il inclus dans votre prestation ?",
    faq_a5: "Oui, Yohann est télépilote de drone professionnel certifié par la DGAC. Les prises de vue aériennes de votre domaine, château ou lieu de cérémonie sont incluses dans nos créations vidéo et duo, sous réserve des autorisations préfectorales et météo.",
  },
  en: {
    // Nav / Header
    nav_portfolio: "Portfolio",
    nav_duo: "The Duo",
    nav_seo: "AI & SEO Profile",
    nav_contact: "Contact",
    nav_style: "Style:",
    nav_admin_exit: "Exit Admin",
    nav_admin_enter: "Admin",
    nav_cta: "Tell My Story",
    nav_sub_brand: "Châteaux & Exceptional Weddings",

    // Hero
    hero_title: "LIFE-CAPTURED",
    hero_tagline: "The art of movement & the poetry of light",
    hero_description: "LIFE-CAPTURED is an exceptional visual creation studio based in Le Teich (Arcachon Bay). Led by Yohann (cinematic film director) and Aurélie (intimate portrait photographer), we sublimate your prestigious weddings, estates, and châteaux throughout Aquitaine.",

    // Portfolio
    portfolio_tag: "Prestige Galleries",
    portfolio_title: "Stories of Love & Light",
    portfolio_subtitle: "Discover our latest tales of love and light, captured spontaneously between land and sea.",
    portfolio_filter_all: "All",
    portfolio_filter_photo: "Photo",
    portfolio_filter_video: "Video",
    portfolio_filter_album: "Fine Art",
    portfolio_view_btn: "View Gallery",
    portfolio_empty: "No media found.",
    portfolio_ex_reportage: "Exceptional Story",
    portfolio_film_hdr: "HDR FILM",
    portfolio_photo_num: "DIGITAL PHOTO",
    portfolio_seo_alt: "SEO Alt-tag:",
    portfolio_prev: "Previous media",
    portfolio_next: "Next media",
    portfolio_close: "Close",

    // ServiceAreas / SEO Localisation
    seo_local_tag: "Regional Anchorage & Mobility",
    seo_local_title: "Your story immortalized on the Arcachon Bay & Aquitaine",
    seo_local_desc: "We operate as <strong>professional wedding photographer and videographer</strong> across all towns of the Arcachon Bay. Our deep understanding of tides, the sun's path on the Dune of Pilat, and the most secret oyster ports allows us to guide you to confidential locations. We also cover the prestigious estates of Bordeaux and the entire Aquitaine, with complete flexibility for national and European travel depending on demand.",
    seo_local_title_1: "The Gem of Arcachon Bay",
    seo_local_sub_1: "Our daily creative anchor",
    seo_local_desc_1: "Based in Le Teich, the unique light of the Bay feeds our creativity. From the wild shores of Cap Ferret to the historic villas of Arcachon's Winter Town, we capture the spirit of our coast.",
    seo_local_title_2: "Châteaux & Aquitaine Vineyards",
    seo_local_sub_2: "Prestige and historical heritage",
    seo_local_desc_2: "We regularly capture exceptional weddings and luxury estates among the finest vineyards and medieval castles in the Bordeaux region.",
    seo_local_title_3: "Mobility Without Borders",
    seo_local_sub_3: "According to demand and scope",
    seo_local_desc_3: "While the Arcachon Bay and Gironde are our favorite areas, our duo travels throughout France and Europe to capture prestigious projects.",
    seo_local_sectors: "Areas of intervention:",
    seo_local_guarantee_title: "Planning, Tides & Local Logistics",
    seo_local_guarantee_desc: "We adapt the timing of your couple sessions based on the Arcachon Bay tide schedules and coastal winds for a magical result.",
    seo_local_guarantee_cta: "Check availability",

    // DuoProfile
    duo_tag: "The Artist Duo",
    duo_title: "The Crafters of Your Memories",
    duo_desc: "A complementary artist couple combining the poetry of spontaneous photography with the cinematic power of narrative films to immortalize your precious moments in Le Teich and throughout Aquitaine.",
    duo_sub_title: "Two Perspectives, One Synergy",
    duo_equip_vid: "STATE-OF-THE-ART GEAR:",
    duo_equip_pho: "CAMERA GEAR:",
    duo_quote: "The strength of a duo is being in the same place under two different magical angles.",
    duo_synergy: "Synchronized Photographer + Videographer for perfect harmony",

    // Showreel
    showreel_tag: "Works in motion",
    showreel_title: "Showreels & Cinematic Stories",
    showreel_desc: "Immerse yourself in our visual world through our snippets of luxury wedding films and prestigious creations.",
    showreel_watch: "Watch the film",
    showreel_intro_tag: "Emotional Immersion",
    showreel_intro_title: "Cinematic Showreel",
    showreel_intro_desc: "A wedding film doesn't just document, it freezes the heartbeat of a day. Watch our exclusive showreel and feel the authentic vibe of our creations.",
    showreel_pitch1_title: "Authenticity",
    showreel_pitch1_desc: "No forced smiles or heavy setups. We capture stolen laughs, soft tears, and shared silences.",
    showreel_pitch2_title: "Pro Cinema Quality",
    showreel_pitch2_desc: "Shot on Sony FX3 & FX30 4K Log with Atomos recorder, DJI RS3 Pro gimbal, Zeapon motorized slider, and 4K DJI Mini 4 Pro drone.",
    showreel_pitch3_title: "Sound of Emotion",
    showreel_pitch3_desc: "Sound is 50% of the experience: we record your vows, speeches, and ambient soundscapes for an immersive story.",
    showreel_ambient_badge: "CINEMATIC STORY • 4K HDR",
    showreel_demo_badge: "Showreel:",
    showreel_open_external: "Open on YouTube / Vimeo ↗",

    // FeaturedMasterpiece
    master_tag: "Prestige Selection",
    master_title: "The Masterpieces",
    master_desc: "A living collection of our finest creations. Click the star ⭐ icon on your favorite gallery photos to feature them in random rotation right here!",
    master_quote_fallback: "Art is the assembly of scattered fragments of eternity.",
    master_author_fallback: "Artistic statement by Aurélie & Yohann",
    master_btn_reassemble: "Next ➔",
    master_teaser_tag: "Emergence of the Moment",
    master_teaser_desc: "Discover our favorite captures",

    // Contact
    contact_tag: "Write your legend",
    contact_title: "Begin the Adventure",
    contact_label_name: "First & Last Name",
    contact_label_email: "Email Address",
    contact_label_phone: "Phone Number",
    contact_label_date: "Event Date",
    contact_label_location: "Event Location",
    contact_label_message: "Your project (mood, desires...)",
    contact_submit: "Send Message",
    contact_success_title: "Message sent successfully!",
    contact_success_desc: "We will get back to you within 24-48 hours.",
    contact_intro_tag: "Tell us about your project",
    contact_intro_title: "Elevate your memories",
    contact_intro_desc: "Whether it's an intimate wedding on the Bay, a grandiose celebration in a Bordeaux château, or showcasing an exceptional estate, we are here to listen.",
    contact_studio_label: "Our Studio",
    contact_hours_label: "Opening Hours",
    contact_social_label: "Join us on social media",
    contact_placeholder_name: "e.g., Alexander & Sophie",
    contact_placeholder_email: "e.g., contact@mymail.com",
    contact_placeholder_phone: "e.g., +33 6 12 34 56 78",
    contact_placeholder_location: "e.g., Roquetaillade Castle, Larchey Estate, etc.",
    contact_placeholder_message: "Tell us about the atmosphere, your artistic expectations, the package that interests you (Photo, Video, or full Duo)...",
    contact_sending: "Sending...",
    contact_btn_send: "Send our request",
    contact_success_thanks: "Thank you infinitely for sharing your story with us. Aurélie and Yohann will study your project within 24 hours and get back to you with a tailor-made proposal.",
    contact_success_btn_another: "Send another message",

    // FAQ
    faq_tag: "Answers to your questions",
    faq_title: "Frequently Asked Questions",
    faq_q1: "What areas do you cover?",
    faq_a1: "We are based on the Arcachon Bay (Le Teich) and travel throughout Gironde, Aquitaine (Bordeaux, Saint-Émilion, Cap Ferret), as well as across France and internationally.",
    faq_q2: "Do you offer combined photo and video packages?",
    faq_a2: "Yes, our absolute specialty is the complete Duo package. Working together as a couple allows us to ensure perfect visual harmony, avoid physical interference on-site, and fully synchronize our shots.",
    faq_q3: "What is your delivery timeline?",
    faq_a3: "For story photos (delivered via a private online gallery), the timeline is 4 to 6 weeks. For the cinematic film, detailed sound design and meticulous color grading usually take 6 to 8 weeks.",
    faq_q4: "How do we organize our collaboration before the big day?",
    faq_a4: "We schedule several planning sessions (in-person or video call) to get to know you. We study the timeline together, analyze tide schedules and sun placement to orchestrate the couple session during golden hour.",
    faq_q5: "Is drone coverage included in your services?",
    faq_a5: "Yes, Yohann is a professional drone pilot certified by the DGAC (aviation authority). Spectacular aerial shots of your estate or château are included in our video and duo packages, subject to flight clearances and favorable weather.",
  }
};

type Translations = typeof translations;
export type TranslationKey = keyof Translations['fr'];

interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: TranslationKey) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState<Language>(() => {
    const cached = localStorage.getItem('life_captured_lang');
    if (cached === 'en' || cached === 'fr') return cached as Language;
    
    // Default to 'fr' but check browser language
    try {
      const browserLang = navigator.language.split('-')[0];
      if (browserLang === 'en') return 'en';
    } catch (_) {}
    return 'fr';
  });

  const setLang = (newLang: Language) => {
    setLangState(newLang);
    localStorage.setItem('life_captured_lang', newLang);
  };

  useEffect(() => {
    // Dynamic lang attribute update for SEO and Accessibility
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  const t = (key: TranslationKey): string => {
    return translations[lang][key] || translations['fr'][key] || String(key);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
